"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatesButton = void 0;
var React = require("react");
var StatesButton_st_css_1 = require("./StatesButton.st.css");
var Button_1 = require("../Button");
var constants_1 = require("./constants");
var deprecationLog_1 = require("../../common/deprecationLog");
var Check_1 = require("wix-ui-icons-common/on-stage/Check");
var StatesButton = /** @class */ (function (_super) {
    __extends(StatesButton, _super);
    function StatesButton(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (_a) {
            var prevState = _a.state;
            var _b = _this.props, currentState = _b.state, onNotificationEnd = _b.onNotificationEnd;
            if (currentState !== prevState) {
                clearTimeout(_this.timer);
            }
            if ((currentState === constants_1.BUTTON_STATES.SUCCESS &&
                prevState !== constants_1.BUTTON_STATES.SUCCESS) ||
                (currentState === constants_1.BUTTON_STATES.FAILURE &&
                    prevState !== constants_1.BUTTON_STATES.FAILURE)) {
                _this.timer = setTimeout(function () { return onNotificationEnd && onNotificationEnd(); }, 2000);
            }
        };
        _this.buttonRef = React.createRef();
        _this.focus = function () {
            _this.buttonRef.current.focus();
        };
        _this.debounceOnClick = function (e) {
            var _a = _this.props, state = _a.state, onClick = _a.onClick;
            if (state === constants_1.BUTTON_STATES.IDLE) {
                onClick(e);
            }
        };
        deprecationLog_1.wrap('Button');
        return _this;
    }
    StatesButton.prototype.componentDidMount = function () {
        if (!this.props.upgrade) {
            deprecationLog_1.deprecationLog('StatesButton', 'The current `StatesButton` component API will be deprecated in a future version. Please use the `upgrade` prop in order to use the new API.');
            deprecationLog_1.unwrap('Button');
        }
    };
    StatesButton.prototype.renderCheck = function () {
        return (React.createElement("div", { className: StatesButton_st_css_1.classes.successIconWrapper },
            React.createElement(Check_1.default, { className: StatesButton_st_css_1.classes.successIcon, "data-hook": "checkIcon" })));
    };
    StatesButton.prototype.renderContent = function () {
        var _a = this.props, state = _a.state, idleContent = _a.idleContent, inProgressContent = _a.inProgressContent, failureContent = _a.failureContent, successContent = _a.successContent;
        switch (state) {
            case constants_1.BUTTON_STATES.IDLE:
                return idleContent;
            case constants_1.BUTTON_STATES.IN_PROGRESS:
                return inProgressContent;
            case constants_1.BUTTON_STATES.FAILURE:
                return failureContent;
            case constants_1.BUTTON_STATES.SUCCESS:
                return successContent ? successContent : this.renderCheck();
            default:
                return idleContent;
        }
    };
    StatesButton.prototype.render = function () {
        var _a = this.props, state = _a.state, disabled = _a.disabled, onClick = _a.onClick, idleContent = _a.idleContent, inProgressContent = _a.inProgressContent, failureContent = _a.failureContent, successContent = _a.successContent, onNotificationEnd = _a.onNotificationEnd, upgrade = _a.upgrade, className = _a.className, rest = __rest(_a, ["state", "disabled", "onClick", "idleContent", "inProgressContent", "failureContent", "successContent", "onNotificationEnd", "upgrade", "className"]);
        var inProgress = state === constants_1.BUTTON_STATES.IN_PROGRESS;
        return (React.createElement(Button_1.Button, __assign({ className: StatesButton_st_css_1.st(StatesButton_st_css_1.classes.root, { upgrade: upgrade }, className), upgrade: upgrade, disabled: disabled, onClick: this.debounceOnClick, ref: this.buttonRef, "aria-live": "assertive" }, (inProgress && { 'aria-busy': true }), rest), this.renderContent()));
    };
    return StatesButton;
}(React.Component));
exports.StatesButton = StatesButton;
//# sourceMappingURL=StatesButton.js.map